import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "arrow-right-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.1014 5.04647C14.8084 4.7537 14.3335 4.75391 14.0407 5.04693C13.748 5.33995 13.7482 5.81482 14.0412 6.10759L19.1881 11.25H3C2.58579 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.58579 12.75 3 12.75H19.1881L14.0412 17.8924C13.7482 18.1852 13.748 18.6601 14.0407 18.9531C14.3335 19.2461 14.8084 19.2463 15.1014 18.9535L21.5214 12.5391C21.6624 12.4027 21.75 12.2116 21.75 12C21.75 11.7882 21.6622 11.5969 21.521 11.4605L15.1014 5.04647Z" }, null, -1)
  ])))
}
export default { render: render }